import React from 'react';
import { useSelector } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
import { isReactionsButtonEnabled, isReactionsEnabled } from '../../functions.web';
import RaiseHandButton from './RaiseHandButton';
import ReactionsMenuButton from './ReactionsMenuButton';
const RaiseHandContainerButton = (props) => {
    const reactionsButtonEnabled = useSelector(isReactionsButtonEnabled);
    const reactionsEnabled = useSelector(isReactionsEnabled);
    const isNarrowLayout = useSelector((state) => state['features/base/responsive-ui'].isNarrowLayout);
    const showReactionsAsPartOfRaiseHand = !reactionsButtonEnabled && reactionsEnabled && !isNarrowLayout && !isMobileBrowser();
    return showReactionsAsPartOfRaiseHand
        ? React.createElement(ReactionsMenuButton, { ...props, showRaiseHand: true })
        : React.createElement(RaiseHandButton, { ...props });
};
export default RaiseHandContainerButton;
